
import { useMenuBootstrap } from "../features/navigation/hooks/useMenuBootstrap";
import { RouteGenerator } from "../routes/RouteGenerator";
import { useAuthSync } from "../features/auth/hooks/useAuthSync";
import { PageTitleManager } from "../routes/dynamicTitle/PageTitleManager";

export const App = () => {
  useMenuBootstrap();
  useAuthSync();
  return (
    <>
      <PageTitleManager />
      <RouteGenerator />
    </>
  );
};
